import React, { Component, Fragment } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ResizeDetector from 'react-resize-detector';
import cx from 'classnames';
import { connect } from 'react-redux';

import Routes from './router/Routes';
import './App.css';

class App extends Component {

  render() {

    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      // enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    } = this.props;

    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <Router>
              <div className={cx(
                `app-container app-theme-${colorScheme}`,
                { 'fixed-header': enableFixedHeader },
                { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
                { 'fixed-footer': enableFixedFooter },
                // { 'closed-sidebar': enableClosedSidebar || width < 1250 },
                { 'closed-sidebar': true },
                { 'closed-sidebar-mobile': closedSmallerSidebar || width < 1250 },
                { 'sidebar-mobile-open': enableMobileMenu },
                { 'body-tabs-shadow-btn': enablePageTabsAlt },
              )}>

                <Routes />

              </div>
            </Router>
          </ Fragment>
        )}
      />
    );
  }
}

const mapStateToProp = state => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,

})

export default connect(mapStateToProp)(App);
